export const WhatsappConstants = {
    WHATSAPP_GATEWAY_IDENTITY: 'postmaster@wa.gw.msging.net',
    CURRENCY_CODE: 'USD',
    PROFILE_URI: '/profile',
    PHONE_NUMBER_DETAILS_URI: '/phone-number-details',
    WABAS_DETAILS_URI: '/wabas/details',
    BUSINESS_DETAILS_URI: '/business',
    STATE_CONFIGURATIONS_URI: '/state-configurations',
    CONTAINER_CONFIGURATION_URI: '/container-configuration',
    NUMBERS_BALANCE_URI: '/numbers-balance',
    WABAS_WITH_FILTERS_URI: '/wabas?userAccessToken=',
    WABAS_WITH_SUBSIDIARY_FILTER_URI: '&subsidiary=',
    PROFILE_RESOURCE_TYPE: 'application/vnd.iris.whatsapp.profile+json',
    DEFAULT_RESOURCE_TYPE: 'application/json',
    MESSAGE_TEMPLATE_INSIGHTS: '/message-templates-insights',
    INSIGHTS: '/insights',
};
